var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_235)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_163_235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6651 6.65773C9.81098 5.70875 8.96543 4.76834 8.12416 3.8322C7.25147 2.86611 6.38307 1.90429 5.51181 0.941406C3.8207 0.942476 2.12531 0.944616 0.41992 0.945686C1.24833 1.87112 2.08246 2.80299 2.92516 3.74447C3.13654 3.97449 3.56932 4.45166 4.14492 5.09144C4.69339 5.70234 5.38183 6.46622 6.13454 7.30393C5.18758 8.32887 4.14207 9.46186 3.13226 10.5553C1.99391 11.7845 0.898399 12.9678 0 13.9382C1.35117 13.9393 2.4581 13.9403 3.18796 13.9414C3.29366 13.9414 3.39935 13.9414 3.50504 13.9403C3.91925 13.9403 4.35059 13.9403 4.79337 13.9414C5.0476 13.6643 5.30755 13.3829 5.56608 13.1016C5.79889 12.8459 6.0317 12.5912 6.2588 12.343C6.71157 11.8466 7.14006 11.3737 7.49999 10.9693C7.90706 10.5061 8.32127 10.0353 8.73261 9.56671C8.52551 9.7764 8.33412 9.97112 8.16701 10.1402C8.60121 9.67049 9.03541 9.20081 9.19253 9.01573C10.0938 8.00363 9.54531 8.55782 9.15539 8.92479C9.02541 9.05424 9.03256 9.03177 9.02827 9.02107L10.7637 7.1381L6.48019 2.39108C6.76728 2.68209 6.98724 2.89927 6.87726 2.742C7.30289 3.21489 7.94134 3.92635 7.98847 3.95524C8.1313 4.04297 8.5098 4.38211 9.66815 5.62423C10.1181 6.11317 10.7808 6.87705 10.9465 7.04502C11.2093 7.30928 10.4052 6.39133 10.6651 6.65773Z",
    fill: "#FFD500"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    fill: "white",
    transform: "translate(0 0.941406)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_163_235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    fill: "white",
    transform: "translate(0 0.941406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterArrows);
export default __webpack_public_path__ + "static/media/footerArrows.b87cae6b463a085f27c71348283eb7fe.svg";
export { ForwardRef as ReactComponent };